import React from 'react';
import { DEADLINES } from '../../../../enums/extensionShortIdEnum';
import { MissingExtensionModal } from '../missingExtensionModal/modal';
import { NO_DEADLINES_EXT } from '../../../../enums/templateItemsEnum';

export const MissingDeadlinesModal = React.memo(() => (
    <MissingExtensionModal extensionShortId={DEADLINES} templateContent={NO_DEADLINES_EXT} />
));
